<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <template>
            <v-card>
              <hr style="margin:0"/>
              <v-card-title>
                Agencies ({{ addTSBVZ(totalRecords) }})
                <v-spacer></v-spacer>
                <v-text-field
                    @keydown.enter="searchQueryData"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
              </v-card-title>
              <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"
              >
              </v-skeleton-loader>
              <v-data-table
                  :headers="headers"
                  :items="items"
                  show-expand
                  :options.sync="pagination"
                  :server-items-length="totalRecords"
                  :footer-props="{
                    itemsPerPageOptions: rowsPerPageItems,
                    showFirstLastPage: true,
                  }"
                  :loading="loading"
                  v-show="!isLoaded"
                  mobile-breakpoint="100"
                  class="elevation-0">
                <template v-slot:item.name="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.name }}</p>
                  </div>
                </template>
                <template v-slot:item.email="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.email }}</p>
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="text-truncate">
                    {{ formatDateAndTime(item.created_at) }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-truncate">
                    <v-btn color="red" dark @click="deleteItem(item)" class="mr-2">
                      Delete
                      <v-icon dark right small>fas fa-trash</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-row>
                      <v-col cols="12">
                        <v-card
                            class="mx-auto"
                            outlined
                            rounded
                        >
                          <v-card-text class="pt-0 pb-0">
                            <v-row>
                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Name</h6>
                                  <p>{{ item.name ? item.name : 'N/A' }}</p>
                                </div>
                                <div>
                                  <h6>Email</h6>
                                  <p>{{ item.email ? item.email : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Phone</h6>
                                  <p>{{ item.number ? item.number : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Project(s)</h6>
                                  <div v-if="$store.state.auth.user.type === 1">
                                    <p v-for="(project, ind) in item.agency_projects" :key="ind">{{ project.project ? project.project.title : '' }}</p>
                                  </div>
                                  <div v-else>
                                    <p v-for="(project, ind) in item.developer_agency_projects" :key="ind">{{ project.project ? project.project.title : '' }}</p>
                                  </div>
                                </div>
                                <div>
                                  <h6>Address</h6>
                                  <p>{{ item.address ? item.address : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Copy of Visa</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.visa_file)">{{ item.visa_file ? 'View' : '-' }}</a></p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Trade License Number</h6>
                                  <p>{{ item.trade_license_number ? item.trade_license_number : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License Issue Date</h6>
                                  <p>{{ item.tln_issue_date ? item.tln_issue_date : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License Expiry Date</h6>
                                  <p>{{ item.tln_expiry_date ? item.tln_expiry_date : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Trade License</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.tln_file)">{{ item.tln_file ? 'View' : '-' }}</a></p>
                                </div>
                                <div>
                                  <h6>Tax Registration Number</h6>
                                  <p>{{ item.trn ? item.trn : '-' }}</p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Tax Registration Certificate</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.trn_file)">{{ item.trn_file ? 'View' : '-' }}</a></p>
                                </div>

                                <div>
                                  <h6>Organization Registration Number</h6>
                                  <p>{{ item.organization_registration_number ? item.organization_registration_number : '-' }}</p>
                                </div>

                                <div>
                                  <h6>Organization Registration Certificate</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.orn_file)">{{ item.orn_file ? 'View' : '-' }}</a></p>
                                </div>

                                <div>
                                  <h6>Memorandum Of Agreement (MOA)</h6>
                                  <p><a style="color: blue" target="_blank" :href="buildFileUrl(item.moa_file)">{{ item.moa_file ? 'View' : '-' }}</a></p>
                                </div>
                                <div>
                                  <h6>Bank Title</h6>
                                  <p>{{ item.bank_title ? item.bank_title : '-' }}</p>
                                </div>
                              </v-col>

                              <v-col cols="12" sm="3">
                                <div>
                                  <h6>Bank IBAN</h6>
                                  <p>{{ item.bank_iban ? item.bank_iban : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Name</h6>
                                  <p>{{ item.bank_name ? item.bank_name : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Other Bank Name</h6>
                                  <p>{{ item.other_bank_name ? item.other_bank_name : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Branch</h6>
                                  <p>{{ item.bank_branch ? item.bank_branch : '-' }}</p>
                                </div>
                                <div>
                                  <h6>Bank Swift Code</h6>
                                  <p>{{ item.bank_swift ? item.bank_swift : '-' }}</p>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                <h3>Owners Details:</h3><br>
                                <div class="bg-white">
                                  <v-simple-table dense>
                                    <template v-slot:default>
                                      <thead>
                                      <tr>
                                        <th class="text-left">
                                          Emirates ID Number
                                        </th>
                                        <th class="text-left">
                                          Contact Number
                                        </th>
                                        <th class="text-left">
                                          Email
                                        </th>
                                        <th class="text-left">
                                          Passport Number
                                        </th>
                                        <th class="text-left">
                                          Emirates ID
                                        </th>
                                        <th class="text-left">
                                          Passport Copy
                                        </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr
                                          v-for="(owner, i) in item.agency_owners"
                                          :key="i"
                                      >
                                        <td>{{ owner.owner_emirates_id }}</td>
                                        <td>{{ owner.country_code ? '+' + owner.country_code + owner.number : owner.number }}</td>
                                        <td>{{ owner.email }}</td>
                                        <td>{{ owner.owner_passport_number }}</td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(owner.owner_emirates_id_file)">{{ owner.owner_emirates_id_file ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(owner.owner_passport_file)">{{ owner.owner_passport_file ? 'View' : '-' }}</a>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                <h3>Brokers Details:</h3><br>
                                <div class="bg-white">
                                  <v-simple-table dense>
                                    <template v-slot:default>
                                      <thead>
                                      <tr>
                                        <th class="text-left">
                                          Name
                                        </th>
                                        <th class="text-left">
                                          Contact Number
                                        </th>
                                        <th class="text-left">
                                          Email
                                        </th>
                                        <th class="text-left">
                                          Broker Registration Number
                                        </th>
                                        <th class="text-left">
                                          Passport Copy
                                        </th>
                                        <th class="text-left">
                                          Emirates ID
                                        </th>
                                        <th class="text-left">
                                          Broker ID
                                        </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr
                                          v-for="(broker, i) in item.agency_brokers"
                                          :key="i"
                                      >
                                        <td>{{ broker.name }}</td>
                                        <td>{{ broker.country_code ? '+' + broker.country_code + broker.number : broker.number }}</td>
                                        <td>{{ broker.email }}</td>
                                        <td>{{ broker.brn }}</td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.passport_copy)">{{ broker.passport_copy ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.emirates_id)">{{ broker.emirates_id ? 'View' : '-' }}</a>
                                        </td>
                                        <td>
                                          <a style="color: blue" target="_blank" :href="buildFileUrl(broker.broker_id)">{{ broker.broker_id ? 'View' : '-' }}</a>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </td>
                </template>
              </v-data-table>
              <!-- this dialog is used for both create and update -->
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
  USERS_LIST,
  CREATE_DEVELOPER,
  UPDATE_DEVELOPER,
  CLEAR_USER_ERRORS,
  GET_DEVELOPER_DETAILS,
  DELETE_AGENCY,
} from "@/core/services/store/users.module";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";
import {CONTACTS_SIMPLE_LIST} from "@/core/services/store/contacts.module";
import {buildFileUrl} from "@/utils/fileUrl";
export default {
  name: 'agencies',
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name', name: 'name', filterable: true, sortable: true},
        {text: 'Email', value: 'email', name: 'email', filterable: true, sortable: true},
        {text: 'Phone', value: 'number', name: 'number', filterable: true, sortable: true},
        {text: 'Referred By', value: 'referred_by.name', name: 'referred_by', filterable: false, sortable: false},
        {text: "Registered At", value: "created_at", name: "created_at", filterable: true, sortable: true},
        {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
      ],
      isLoaded: true,
      draw: 1,
      searchQuery: "",
      loading: true,
      developersFilter: [],
      isDevelopersLoaded: false,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortDesc: "desc"
      },
      totalRecords: 0,
      rowsPerPageItems: [25, 50, 100, 150, 200],
      headerindex: "",
      columns: [],
      validationRules: {
        valid: true,
        selectRule: [
          (v) => {
            if (!v || v.length < 1)
              return 'Select an option';
            else return true;
          }
        ],
        nameRules: [
          v => !!v || "Name is required",
          v => (v && v.length >= 3) || "Name must be greater than or equal to 3 characters",
          v => (v && v.length <= 50) || "Name must be less than or equal to 50 characters"
        ],
        emailRules: [
          v => !!v || "Email is required",
          v => (v && v.length <= 30) || "Must be less than or equal to 30 characters",
          v => /.+@.+\..+/.test(v) || "Email must be valid"
        ],
      },
      items: [],
      dialog: false,
      editedItem: {},
      show: false,
    }
  },
  watch: {
    params: {
      handler() {
        this.loadData().then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
        });
      },
      deep: true
    },
    dialog(val) {
      !val && this.$store.dispatch(CLEAR_USER_ERRORS);
      if (!val) this.editedItem = {};
    }
  },
  mounted() {
    for (var i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].value +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Contact's Management", route: "vendors"},
      {title: "Vendors"}
    ]);
    if (this.$route.query.hasOwnProperty('addModule')) {
      this.dialog = true;
    }
  },
  methods: {
    buildFileUrl,
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    searchQueryData: function (e) {
      if (e.keyCode === 13) {
        this.searchQuery = e.target.value;
      }
    },
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData() {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        params.length = params.itemsPerPage; //set how many records to fetch per page
        params.start =
            params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        this.getHeaderIndex(params.sortBy[0]);
        query +=
            "&type=3" +
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            (params.sortBy.length === 0 ? 4 : this.headerindex) +
            "&order[0][dir]=" +
            (params.sortDesc[0] ? "desc" : "asc");
        this.$store.dispatch(USERS_LIST, {q: query, columns: this.columns}).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    showEditDialog(item) {
      this.$store.dispatch(GET_DEVELOPER_DETAILS, item.id).then((data) => {
        let conArr = []
        this.editedItem = data.records || {};
        if (data.records.contact) {
          conArr.push(data.records.contact)
          this.developersFilter = conArr;
        }
        this.dialog = !this.dialog;
      });
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    saveItem(item) {
      if (this.$refs.form.validate()) {
        let method = CREATE_DEVELOPER;
        let id = item.id;
        let data = {
          data: item
        };
        if (id) {
          method = UPDATE_DEVELOPER;
          // delete data.data.id;
        }
        this.$store.dispatch(CLEAR_USER_ERRORS);
        this.$store.dispatch(method, {'slug': id, data: data.data}).then(() => {
          this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
          });
          this.editedItem = {}
          this.dialog = !this.dialog
          if (this.$route.query.hasOwnProperty('addModule')) {
            window.close();
          }
        })
      }
    },
    deleteItem(item) {
      let that = this;
      this.$store.dispatch(SET_CONFIRMATION, {
        title: "Are you sure?",
        msg: "You want to delete '" + item.name + "'? All agency documents will also be removed from storage.",
        clr: 'red',
        callback: function () {
          this.$store.dispatch(DELETE_AGENCY, {
            'id': item.id
          }).then(() => {
            that.loadData().then(response => {
              that.items = response.items;
              that.totalRecords = response.total;
            });
          });
        }
      });
    },
    developersFilterKeyUp(e) {
      clearTimeout(this.apiTimeout)
      let that = this
      this.apiTimeout = setTimeout(function () {
        if (e.target.value.length >= 3) {
          that.isDevelopersLoaded = true;
          that.$store
              .dispatch(CONTACTS_SIMPLE_LIST, {
                role: 'Developers',
                q: e.target.value
              })
              .then(data => {
                that.developersFilter = that.developersFilter.concat(data.records.contactsList);
                that.isDevelopersLoaded = false;
              });
        }
      }, 900);
    },
  },
  computed: {
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery
      };
    },
    ...mapState({
      errors: state => state.users.errors
    })
  }
};
</script>